/**
 * Stable CSS class names for E2E — OmniChannelService card.
 */
export const SM_OCS = {
    card: 'service-managment-omni-channel__card',
    row: 'service-managment-omni-channel__row',
    title: 'service-managment-omni-channel__title',
    toggle: 'service-managment-omni-channel-input--toggle',
} as const;

export const smOcsCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

